// extracted by mini-css-extract-plugin
export default {"NoData":"NoData_NoData__RYEbP"};